import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { checkAuth, initializeUserSession } from 'src/redux/thunks/authThunks';
import { isTenantDomain } from 'src/utils/domainContext';
import SplashScreen from 'src/components/loading-screen/splash-screen'; // Optional

export default function GuestGuard({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isAuthenticated, isInitialized, isSessionLoaded, sites } = useSelector((state) => state.auth);

  // Trigger checkAuth and initializeUserSession only once
  useEffect(() => {
    if (!isInitialized) {
      dispatch(checkAuth());
      dispatch(initializeUserSession());
    }
  }, [dispatch, isInitialized]);

  // Optional: you can show a splash screen while checking auth
  if (!isInitialized || !isSessionLoaded) {
    return <SplashScreen />; // or return null
  }

  // Only redirect to dashboard if truly authenticated AND
  // (on a tenant domain) the user has sites for this tenant
  if (isAuthenticated) {
    if (isTenantDomain() && (!sites || sites.length === 0)) {
      // User is authenticated via cookie but doesn't belong to this tenant.
      // Let them stay on the login page so they can log in with proper credentials.
      return children;
    }

    const redirectPath = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};
